// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._JjgtqcdoKu9hAONsyef {
    padding: 2rem;
    background: white;
}

.gCZ3leDdHNY4t7VD4vUQ {
    padding-top: 1rem;
    width: 65%;
    max-width: 65%;
    display: grid;
    grid-template-columns: repeat(3, minmax(auto, calc(85% / 3)));
    gap: 2rem;
}

.l4qvQimH802xSin4DVSR {
    padding-top: 1rem;
    width: 65%;
    max-width: 65%;
}


.l4qvQimH802xSin4DVSR .PK2H_X0NH0bKOqwSNk3J {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    margin-bottom: 1rem;
}

.l4qvQimH802xSin4DVSR .PK2H_X0NH0bKOqwSNk3J .DUvUMC0KHh3oc6WCMG2u {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex: 1;
    margin-right: 1rem;
}

.l4qvQimH802xSin4DVSR .PK2H_X0NH0bKOqwSNk3J .u_zyh3FnJ4RP3eHP2o1I {
    flex: 4;
}

.l4qvQimH802xSin4DVSR .PK2H_X0NH0bKOqwSNk3J ._sqAPndDd5lZuhed9Wko {
    height: 100%;
    width: 200px;
    object-fit: contain;
    margin-right: 1rem;
}

._sqAPndDd5lZuhed9Wko {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 0.5rem;
    margin-bottom: 1rem;
}

.bva5naVImzWK82JDc7vG {
    color: #000;
    font-family: Inter, sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 1.875rem */
}

.tpH_HNgAwJeXowKXbvYd {
    color: rgba(0, 0, 0, 0.50);
    font-family: Inter, sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

.ZKCDuVW3ju7hViuH4R8A {
    color: #4F67F3;
    font-family: Inter, sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: 219.5%;
    text-decoration: none;
    margin-top: 1rem;
}

.mbDw3rS1o7CL4kV2SvVE {
    color: rgba(0, 0, 0, 0.70);
    font-family: Inter, sans-serif;
    font-size: 1.125rem;
    margin-bottom: 0.5rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

@media screen and (max-width: 768px) {
    .gCZ3leDdHNY4t7VD4vUQ {
        width: 100%;
        max-width: 100%;
        grid-template-columns: repeat(1, 1fr);
    }
    
    .l4qvQimH802xSin4DVSR {
        padding-top: 1rem;
        display: grid;
        gap: 2rem;
        width: 100%;
        max-width: 100%;
        grid-template-columns: repeat(1, 1fr);
    }

    .l4qvQimH802xSin4DVSR .PK2H_X0NH0bKOqwSNk3J ._sqAPndDd5lZuhed9Wko {
        height: 100%;
        width: 100%;
        object-fit: contain;
        margin-right: 1rem;
    }

    .l4qvQimH802xSin4DVSR .PK2H_X0NH0bKOqwSNk3J {
        display: block;
        flex-direction: row;
        align-items: stretch;
        margin-bottom: 1rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Team/Team.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,aAAa;IACb,6DAA6D;IAC7D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,qCAAqC;IACzC;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,SAAS;QACT,WAAW;QACX,eAAe;QACf,qCAAqC;IACzC;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;IACvB;AACJ","sourcesContent":[".container {\n    padding: 2rem;\n    background: white;\n}\n\n.board {\n    padding-top: 1rem;\n    width: 65%;\n    max-width: 65%;\n    display: grid;\n    grid-template-columns: repeat(3, minmax(auto, calc(85% / 3)));\n    gap: 2rem;\n}\n\n.boardHorizontal {\n    padding-top: 1rem;\n    width: 65%;\n    max-width: 65%;\n}\n\n\n.boardHorizontal .profile {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    margin-bottom: 1rem;\n}\n\n.boardHorizontal .profile .left {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex: 1;\n    margin-right: 1rem;\n}\n\n.boardHorizontal .profile .right {\n    flex: 4;\n}\n\n.boardHorizontal .profile .picture {\n    height: 100%;\n    width: 200px;\n    object-fit: contain;\n    margin-right: 1rem;\n}\n\n.picture {\n    width: 100%;\n    aspect-ratio: 1 / 1;\n    object-fit: cover;\n    border-radius: 0.5rem;\n    margin-bottom: 1rem;\n}\n\n.name {\n    color: #000;\n    font-family: Inter, sans-serif;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 150%; /* 1.875rem */\n}\n\n.job {\n    color: rgba(0, 0, 0, 0.50);\n    font-family: Inter, sans-serif;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n}\n\n.link {\n    color: #4F67F3;\n    font-family: Inter, sans-serif;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 219.5%;\n    text-decoration: none;\n    margin-top: 1rem;\n}\n\n.description {\n    color: rgba(0, 0, 0, 0.70);\n    font-family: Inter, sans-serif;\n    font-size: 1.125rem;\n    margin-bottom: 0.5rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n}\n\n@media screen and (max-width: 768px) {\n    .board {\n        width: 100%;\n        max-width: 100%;\n        grid-template-columns: repeat(1, 1fr);\n    }\n    \n    .boardHorizontal {\n        padding-top: 1rem;\n        display: grid;\n        gap: 2rem;\n        width: 100%;\n        max-width: 100%;\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .boardHorizontal .profile .picture {\n        height: 100%;\n        width: 100%;\n        object-fit: contain;\n        margin-right: 1rem;\n    }\n\n    .boardHorizontal .profile {\n        display: block;\n        flex-direction: row;\n        align-items: stretch;\n        margin-bottom: 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `_JjgtqcdoKu9hAONsyef`,
	"board": `gCZ3leDdHNY4t7VD4vUQ`,
	"boardHorizontal": `l4qvQimH802xSin4DVSR`,
	"profile": `PK2H_X0NH0bKOqwSNk3J`,
	"left": `DUvUMC0KHh3oc6WCMG2u`,
	"right": `u_zyh3FnJ4RP3eHP2o1I`,
	"picture": `_sqAPndDd5lZuhed9Wko`,
	"name": `bva5naVImzWK82JDc7vG`,
	"job": `tpH_HNgAwJeXowKXbvYd`,
	"link": `ZKCDuVW3ju7hViuH4R8A`,
	"description": `mbDw3rS1o7CL4kV2SvVE`
};
export default ___CSS_LOADER_EXPORT___;
